






























import { Revista, RevistasService } from "@/services/revistas.service";
import { Component, Prop, Vue } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import { dateTime } from "@/shared/filters";

@Component({ components: { Loading }, filters: { dateTime } })
export default class CardRevista extends Vue {
  @Prop() idRevista!: string;
  @Prop() idCatalogo!: string;
  revista!: Revista;
  loading = false;
  created() {
    this.fetchRevista();
  }
  public async fetchRevista() {
    this.loading = true;
    if (this.idRevista) {
      this.revista = await RevistasService.obterRevista(this.idRevista);
    } else if (this.idCatalogo) {
      this.revista = await RevistasService.obterRevistaAtivaDoCatalogo(
        this.idCatalogo
      );
    }
    this.loading = false;
  }
}
